export default Object.freeze({
    VISA_IS_AVAILABLE: JSON.parse(process.env.VUE_APP_VISA_IS_AVAILABLE),
    MASTERCARD_IS_AVAILABLE: JSON.parse(process.env.VUE_APP_MASTERCARD_IS_AVAILABLE),
    DANKORT_IS_AVAILABLE: JSON.parse(process.env.VUE_APP_DANKORT_IS_AVAILABLE),
});
